import { render, staticRenderFns } from "./BookingCampaignBanner.vue?vue&type=template&id=52943392"
import script from "./BookingCampaignBanner.vue?vue&type=script&lang=js"
export * from "./BookingCampaignBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports